import { toast } from "@warp-ds/elements";

export const closableErrorToast = (message: string) => {
  toast(message, { type: "error", canclose: true });
};

export const closableSuccessToast = (message: string) => {
  toast(message, { type: "success", canclose: true });
};

export const shortLivedSuccessToast = (message: string) => {
  toast(message, { duration: 2000 });
};
